import DomainSelect from 'volta/components/domain-select';
import { CustomFieldDefinitionResourceName } from 'volta/models/custom-field-definition';
import { defaultErrorHandler } from 'volta/utils/error-utils';
import { sanitized } from 'volta/utils/text-utils';

import { action } from '@ember/object';

import type { TError } from 'volta/utils/error-utils';
import type { TCustomFieldTableValue } from 'volta/models/types/custom-field-definition';
import type CustomFieldDefinition from 'volta/models/custom-field-definition';

interface CustomFieldValuesSelectArgs {
  customFieldDefinition: CustomFieldDefinition;
}

export default class CustomFieldValuesSelect extends DomainSelect<
  TCustomFieldTableValue,
  CustomFieldValuesSelectArgs
> {
  get deferOptionsFetch() {
    return true;
  }

  get renderAll() {
    return true;
  }

  @action
  showCreateWhen(term?: string, options?: any[]) {
    return (
      !this.args.customFieldDefinition.fieldConstraints?.list?.length &&
      super.showCreateWhen(term, options)
    );
  }

  async searchPromise({ search }: Record<string, any>) {
    const { customFieldDefinition } = this.args;
    try {
      const list = customFieldDefinition.fieldConstraints?.list ?? [];

      if (!customFieldDefinition) {
        return [];
      }

      if (list.length > 0) {
        return search && search.length > 0
          ? list.filter((item) => sanitized(item).includes(sanitized(search)))
          : list;
      }

      return await this.store.customQuery(
        CustomFieldDefinitionResourceName.plural,
        'customFieldValues',
        customFieldDefinition.id,
        {
          pageSize: 50,
          searchString: search && search.length > 0 ? search : undefined
        }
      );
    } catch (error) {
      defaultErrorHandler(error as TError);
      return [];
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    CustomFieldValuesSelect: typeof CustomFieldValuesSelect;
    'custom-field-values-select': typeof CustomFieldValuesSelect;
  }
}
